import { ActionContext, Module } from 'vuex';
import { AxiosResponse } from 'axios';
import api from '@/services/Api';
import { successSwal, warningSwal } from '@/helper/swals';
import { TerminplaetzeState, RootState } from '@/store/types';
import {Terminplatz} from '@/types/Terminkalender';

export type UpdateTerminplatzPayload = { terminplatz: Terminplatz };
export type DeleteTerminplatzPayload = { terminplatz: Terminplatz };
export type SetTerminplaetzeDialogs = { edit?: boolean; };
export type SetTerminplaetzeLoaders = { save?: boolean; delete?: boolean; Terminplaetze?: boolean; };

type Context = ActionContext<TerminplaetzeState, RootState>;

export const terminplaetze: Module<TerminplaetzeState, RootState> = {
    namespaced: true,
    state: {
        dialogs: {
            edit: false,
        },
        loaders: {
            save: false,
            delete: false,
            terminplaetze: false,
        },
        terminplaetze: [],
    },
    actions: {
        loadTerminplaetze({ commit }: Context, payload?): void {
            commit('setLoaders', { terminplaetze: true });

            const data = {
                ...payload,
            };

            api.post('verwaltung/terminplaetze/load', data)
                .then(response => commit('setTerminplaetze', response.data.body))
                .catch(console.error)
                .finally(() => commit('setLoaders', { terminplaetze: false }));
        },
        updateTerminplatz({ commit, dispatch, rootState }: Context, { terminplatz }): void {
            commit('setLoaders', { save: true });

            const data = {
                impfstelle_id: rootState.authentication.impfstelle_id,
                ...terminplatz,
            };

            console.log(data);

            api.post('verwaltung/terminplaetze/save', data)
                .then(() => {
                    successSwal('Terminplatz', 'gespeichert');
                    dispatch('loadTerminplaetze');
                    commit('setDialogs', { edit: false });
                })
                .catch(console.error)
                .finally(() => commit('setLoaders', { save: false }));
        },
        deleteTerminplatz({ commit, dispatch, rootState }: Context, { terminplatz }): void {
            commit('setLoaders', { delete: true });

            const data = {
                impfstelle_id: rootState.authentication.impfstelle_id,
                ...terminplatz,
            };

            api.post('verwaltung/terminplaetze/delete', data)
                .then((response: AxiosResponse) => {
                    if (typeof response.data.body !== 'string') {
                        successSwal('Terminplatz', 'gelöscht');
                        dispatch('loadTerminplaetze');
                        commit('setDialogs', { edit: false });
                    } else {
                        warningSwal('Löschung', response.data.body ?? 'Terminplatz ist nicht löschbar.');
                    }
                })
                .catch(console.error)
                .finally(() => commit('setLoaders', { delete: false }));
        },
    },
    mutations: {
        setTerminplaetze(state: TerminplaetzeState, payload: Partial<Terminplatz>[]): void {
            state.terminplaetze = payload.map((data) => new Terminplatz(data));
        },
        setDialogs(state: TerminplaetzeState, dialogs: SetTerminplaetzeDialogs): void {
            state.dialogs = {
                ...state.dialogs,
                ...dialogs,
            };
        },
        setLoaders(state: TerminplaetzeState, loaders: SetTerminplaetzeLoaders): void {
            state.loaders = {
                ...state.loaders,
                ...loaders,
            };
        },
    },
};
